import { SET_REVIEW_DATA, ADD_REVIEW_DATA } from './types';

export const setReviewData = (data) => ({
	type: SET_REVIEW_DATA,
	payload: data
});

export const addReviewData = (data) => ({
	type: ADD_REVIEW_DATA,
	payload: data
});
